import React from 'react';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import {
  CreateMultipleActivitiesButton,
  CreateMultipleKeywordsButton,
  CreateMultipleNotesButton
} from 'common';
import { ORIGIN_TABLE_MAP } from 'features/daily-plan/constants';
import { useKeywordDrawerManager, useNoteDrawerManager } from 'hooks';
import { useActivityDrawerManager } from 'hooks/useActivityDrawerManager';
import strings from 'strings';
import { When } from 'UI/components/atoms';
import { ActivityDrawer } from 'UI/components/organisms/ActivityDrawer';
import { KeywordsFormDrawer } from 'UI/components/organisms/KeywordsFormDrawer/KeywordsFormDrawer';
import NoteForm from 'UI/components/organisms/NoteForm';
import { MULTIPLE_ACTIVITY_CREATION_SECTIONS } from 'UI/constants/defaults';
import { CandidateEntity, EntityType } from 'UI/constants/entityTypes';

const getEntityLabel = totalSelected =>
  totalSelected === 1 ? CandidateEntity.singular : CandidateEntity.title;

export const ResumeBulkActions = ({ selectedItems, totalSelected }) => {
  const managerArgs = {
    table: ORIGIN_TABLE_MAP.ResumeSearch,
    selectedItems: selectedItems?.data,
    selectionType: selectedItems?.type
  };

  const {
    canCreateMultipleNotes,
    formattedSelectedItems: formattedNoteItems,
    handleCloseNoteDrawer,
    handleOpenNoteDrawer,
    isNoteDrawerOpen,
    noteEndpoint
  } = useNoteDrawerManager(managerArgs);

  const {
    canCreateMultipleKeywords,
    formattedSelectedItems: formattedKeywordItems,
    handleCloseKeywordDrawer,
    handleOpenKeywordDrawer,
    isKeywordDrawerOpen,
    keywordEndpoint
  } = useKeywordDrawerManager(managerArgs);

  const {
    activityEndpoint,
    canCreateMultipleActivities,
    formattedSelectedItems: formattedActivityItems,
    handleCloseActivityDrawer,
    handleOpenActivityDrawer,
    isActivityDrawerOpen
  } = useActivityDrawerManager(managerArgs);

  const buildTopContent = section => (
    <>
      <Typography variant="subtitle2" component="h6" gutterBottom>
        {strings.formatString(strings.inventory.shared.listing.multipleActivityCreation.total, {
          activity: section,
          entity: getEntityLabel(totalSelected),
          total: totalSelected
        })}
      </Typography>
      <Divider />
    </>
  );

  return (
    <>
      <When condition={canCreateMultipleNotes}>
        <CreateMultipleNotesButton onClick={handleOpenNoteDrawer} />
      </When>
      <When condition={canCreateMultipleActivities}>
        <CreateMultipleActivitiesButton onClick={handleOpenActivityDrawer} />
      </When>
      <When condition={canCreateMultipleKeywords}>
        <CreateMultipleKeywordsButton onClick={handleOpenKeywordDrawer} />
      </When>

      <When condition={isNoteDrawerOpen}>
        <NoteForm
          endpoint={noteEndpoint}
          extraPayloadData={{ candidates: formattedNoteItems }}
          FPDrawerProps={{ open: isNoteDrawerOpen }}
          onNoteClosed={handleCloseNoteDrawer}
          topContent={buildTopContent(MULTIPLE_ACTIVITY_CREATION_SECTIONS.notes)}
        />
      </When>

      <When condition={isKeywordDrawerOpen}>
        <KeywordsFormDrawer
          endpoint={keywordEndpoint}
          entityType={EntityType.Candidate}
          selectedItems={formattedKeywordItems}
          FPDrawerProps={{ open: isKeywordDrawerOpen }}
          onClose={handleCloseKeywordDrawer}
        />
      </When>

      <When condition={isActivityDrawerOpen}>
        <ActivityDrawer
          extraPayloadData={{ candidates: formattedActivityItems }}
          onClose={handleCloseActivityDrawer}
          open={isActivityDrawerOpen}
          submitEndpoint={activityEndpoint}
          topContent={buildTopContent(MULTIPLE_ACTIVITY_CREATION_SECTIONS.activities)}
        />
      </When>
    </>
  );
};
